import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { Trash } from "@phosphor-icons/react";

export default function Cart() {
  const { items, setQty, remove, total } = useCart();
  const nav = useNavigate();

  return (
    <main className="max-w-5xl mx-auto px-6 lg:px-10 py-16" data-testid="cart-page">
      <p className="overline opacity-60 mb-2">// Bag</p>
      <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mb-10">Your cart</h1>

      {items.length === 0 ? (
        <div className="border border-white/10 p-10 bg-[#111111]">
          <p className="font-sans text-neutral-400 mb-6">Nothing here yet.</p>
          <Link to="/" className="btn-outline-dark" data-testid="cart-browse-link">Browse the shop</Link>
        </div>
      ) : (
        <>
          <div className="space-y-4 mb-10">
            {items.map((i) => (
              <div key={i.id} className="flex items-center gap-6 border border-white/10 p-4 bg-[#111111]"
                   data-testid={`cart-item-${i.id}`}>
                <img src={i.image_url} alt={i.name} className="w-24 h-24 object-cover border border-white/10" />
                <div className="flex-1">
                  <p className="font-display font-bold">{i.name}</p>
                  <p className="font-mono text-sm opacity-60">${i.price.toFixed(2)} each</p>
                </div>
                <div className="flex items-center border border-white/20">
                  <button onClick={() => setQty(i.id, i.qty - 1)} className="px-3 py-1 hover:bg-obsidian hover:text-bone font-mono">−</button>
                  <span className="w-10 text-center font-mono" data-testid={`cart-qty-${i.id}`}>{i.qty}</span>
                  <button onClick={() => setQty(i.id, i.qty + 1)} className="px-3 py-1 hover:bg-obsidian hover:text-bone font-mono">+</button>
                </div>
                <p className="font-mono text-base w-24 text-right">${(i.price * i.qty).toFixed(2)}</p>
                <button onClick={() => remove(i.id)} className="p-2 hover:text-signal" data-testid={`cart-remove-${i.id}`}>
                  <Trash size={18}/>
                </button>
              </div>
            ))}
          </div>
          <div className="flex items-center justify-between border-t border-white/10 pt-6">
            <p className="overline opacity-60">Subtotal</p>
            <p className="font-mono text-2xl" data-testid="cart-total">${total.toFixed(2)}</p>
          </div>
          <div className="flex justify-end mt-8">
            <button onClick={() => nav("/checkout")} className="btn-signal" data-testid="checkout-btn">
              Checkout →
            </button>
          </div>
        </>
      )}
    </main>
  );
}
